import React, { useState } from 'react'
import { Box, Grid, Tab, Tabs } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom';
import SampleModuleVideo from '../Component/SampleModuleVideo';
import SampleModuleInsession from '../Component/SampleModuleInsession';
import bg from '../../src/assets/images/LMS-bg.jpg'
import SampleModuleEngagement from '../Component/SampleModuleEngagement';
import SampleModuleOffsession from '../Component/SampleModuleOffsession';
import SampleModuleDiary from '../Component/SampleModuleDiary';
import SampleModuleFurtherReading from '../Component/SampleModuleFurtherReading';

const SampleModule = () => {
    const [searchParams] = useSearchParams(); // ✅ correct way
    const navigate = useNavigate();

    // get ?tab= value from URL
    const tab = searchParams.get("tab");

    // initialize state from URL param
    const [currentTabIndex, setCurrentTabIndex] = useState(Number(tab) || 0);

    // tab change handler
    const handleTabChange = (e, tabIndex) => {
        setCurrentTabIndex(tabIndex);
        navigate(`/sample-module?tab=${tabIndex}`);
    };
    return (
        <div className="p-md-5 p-3 overallPadding">
            <Grid
                container
                spacing={2}
                style={{
                    width: "100%",
                    margin: "0 0",
                    position: "sticky",
                    top: "0",
                    zIndex: "999",
                    marginBlock: "10px",
                }}
            >
                <Tabs
                    position="static"
                    sx={{
                        backgroundColor: "#611f1e !important",
                        mx: "auto",
                        width: "100%",
                        display: "flex",
                        flexGrow: "1",
                        "& .MuiButtonBase-root": {
                            color: "white", // Change the color of the scroll buttons
                        },
                    }}
                    value={currentTabIndex}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    textColor="white"
                >
                    <Tab
                        className="title-font"
                        label="Video"
                        sx={{
                            width: "16.6%",
                            maxWidth: "100%",
                            color: `${currentTabIndex === 0 ? "#611f1e !important" : "white"
                                }`,
                            background: `${currentTabIndex === 0 ? "white" : "#611f1e !important"
                                }`,
                        }}
                    />
                    <Tab
                        className="title-font"
                        label="In-session Reading"
                        sx={{
                            width: "16.6%",
                            maxWidth: "100%",
                            color: `${currentTabIndex === 1 ? "#611f1e !important" : "white"
                                }`,
                            background: `${currentTabIndex === 1 ? "white" : "#611f1e !important"
                                }`,
                        }}
                    />
                    <Tab
                        className="title-font"
                        label="Engagement"
                        sx={{
                            width: "16.6%",
                            maxWidth: "100%",
                            color: `${currentTabIndex === 2 ? "#611f1e !important" : "white"
                                }`,
                            background: `${currentTabIndex === 2 ? "white" : "#611f1e !important"
                                }`,
                        }}
                    />
                    <Tab
                        className="title-font"
                        label="Off-session Reading"
                        sx={{
                            width: "16.6%",
                            maxWidth: "100%",
                            color: `${currentTabIndex === 3 ? "#611f1e !important" : "white"
                                }`,
                            background: `${currentTabIndex === 3 ? "white" : "#611f1e !important"
                                }`,
                        }}
                    />
                    <Tab
                        className="title-font"
                        label="My Diary"
                        sx={{
                            width: "16.6%",
                            maxWidth: "100%",
                            color: `${currentTabIndex === 4 ? "#611f1e !important" : "white"
                                }`,
                            background: `${currentTabIndex === 4 ? "white" : "#611f1e !important"
                                }`,
                        }}
                    />
                    <Tab
                        className="title-font"
                        label="Suggestion For Further Reading"
                        sx={{
                            width: "16.6%",
                            maxWidth: "100%",
                            color: `${currentTabIndex === 5 ? "#611f1e !important" : "white"
                                }`,
                            background: `${currentTabIndex === 5 ? "white" : "#611f1e !important"
                                }`,
                        }}
                    />
                </Tabs>
                {currentTabIndex === 0 && (
                    <>
                        <Box className="mt-5 w-100">
                            <SampleModuleVideo />
                        </Box>
                    </>
                )}
                {currentTabIndex === 1 && (
                    <>
                        <Box className="mt-5 w-100 shadow-lg border rounded-5" style={{
                            backgroundImage: `url(${bg})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: 'no-repeat'
                        }}>
                            <SampleModuleInsession />
                        </Box>
                    </>
                )}
                {currentTabIndex === 2 && (
                    <>
                        <Box className="mt-5 w-100 shadow-lg border rounded-5" style={{
                            backgroundImage: `url(${bg})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: 'no-repeat'
                        }}>
                            <SampleModuleEngagement />
                        </Box>
                    </>
                )}
                {currentTabIndex === 3 && (
                    <>
                        <Box className="mt-5 w-100" >
                            <SampleModuleOffsession />
                        </Box>
                    </>
                )}
                {currentTabIndex === 4 && (
                    <>
                        <Box className="mt-5 w-100 shadow-lg border rounded-5" style={{
                            backgroundImage: `url(${bg})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: 'no-repeat'
                        }}>
                            <SampleModuleDiary />
                        </Box>
                    </>
                )}
                {currentTabIndex === 5 && (
                    <>
                        <Box className="mt-5 w-100">
                            <SampleModuleFurtherReading />
                        </Box>
                    </>
                )}
            </Grid>
        </div>
    )
}

export default SampleModule